var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { DashboardActionTypes, SetDashboard, SetNumCandidates } from '../actions';
import { DashboardService } from '../services';
export class DashboardEffects {
    constructor(actions$, dashboardService) {
        this.actions$ = actions$;
        this.dashboardService = dashboardService;
        this.loadDashboard$ = this.actions$
            .pipe(ofType(DashboardActionTypes.LoadDashboard))
            .pipe(switchMap(() => this.dashboardService.getDashboard()))
            .pipe(map(dashboard => new SetDashboard({ dashboard })));
        this.loadNumCandidates$ = this.actions$
            .pipe(ofType(DashboardActionTypes.LoadNumCandidates))
            .pipe(switchMap(() => this.dashboardService.getNumCandidates()))
            .pipe(map(numCandidates => new SetNumCandidates({ numCandidates })));
    }
}
__decorate([
    Effect(),
    __metadata("design:type", Object)
], DashboardEffects.prototype, "loadDashboard$", void 0);
__decorate([
    Effect(),
    __metadata("design:type", Object)
], DashboardEffects.prototype, "loadNumCandidates$", void 0);
